/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { type LoginSchema } from '@/routes/(auth)/lib/schema';

export const LoginForm = () => {
  const { t } = useTranslation();
  const form = useFormContext<LoginSchema>();
  return (
    <>
      <div className='grid gap-6'>
        <div className='grid gap-3'>
          <FormField
            control={form.control}
            name='email'
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('auth.login.form.email')}</FormLabel>
                <FormControl>
                  <Input
                    placeholder={t('auth.login.form.email')}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className='grid gap-3'>
          <FormField
            control={form.control}
            name='password'
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('auth.login.form.password')}</FormLabel>
                <FormControl>
                  <Input
                    type='password'
                    placeholder={t('auth.login.form.password')}
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <a
            href='#'
            className='ml-auto text-sm underline-offset-4 hover:underline'>
            {t('auth.login.form.forgotPassword')}
          </a>
        </div>
        <Button
          type='submit'
          className='w-full'>
          {t('auth.login.form.submit')}
        </Button>

        <div className='text-sm flex gap-1 items-center justify-center'>
          {t('auth.login.form.noAccount')}
          <a
            href='#'
            className='underline underline-offset-4'>
            {t('auth.login.form.signUp')}
          </a>
        </div>
      </div>
    </>
  );
};
